module.exports = __webpack_public_path__ + "assets/img/cdc-habitat.3be84c2e.png";